module.exports = __webpack_public_path__ + "img/info.bf10db37.png";